const breaks = {
  huge: '1440px',
  large: '1024px',
  medium: '768px',
  small: '480px',
  tiny: '415px'
}

const less = {
  lessThanHuge: `(max-width: ${breaks.huge})`,
  lessThanLarge: `(max-width: ${breaks.large})`,
  lessThanMedium: `(max-width: ${breaks.medium})`,
  lessThanSmall: `(max-width: ${breaks.small})`,
  lessThanTiny: `(max-width: ${breaks.tiny})`
}

const great = {
  greaterThanHuge: `(min-width: ${breaks.huge})`,
  greaterThanLarge: `(min-width: ${breaks.large})`,
  greaterThanMedium: `(min-width: ${breaks.medium})`,
  greaterThanSmall: `(min-width: ${breaks.small})`,
  greaterThanTiny: `(min-width: ${breaks.tiny})`
}

const between = {
  betweenTinySmall: `${great.greaterThanTiny} and ${less.lessThanSmall}`,
  betweenSmallMedium: `${great.greaterThanSmall} and ${less.lessThanMedium}`,
  betweenMediumLarge: `${great.greaterThanMedium} and ${less.lessThanLarge}`,
  betweenLargeHuge: `${great.greaterThanLarge} and ${less.lessThanHuge}`
}

const mediaQueries = { ...less, ...great, ...between } as const

export type MediaQuery = keyof typeof mediaQueries

export default mediaQueries
